import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class DrugLookupServiceInterface {
    getDrug = (drugName: string): Observable<any> => null;
    getDrugByNDC = (ndc: string): Observable<any> => null;
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/widgets/drug-lookup/drug-lookup-service-interface.service.ts